import styled from 'styled-components';
import { boxStyles, BoxWrapperPropsType } from './boxHelpers';

const FOCUSABLE_PROPS = {
  cursor: 'pointer',
  tabIndex: 0,
  role: 'button',
};

export const BoxWrapper = styled('div').attrs(
  (props: BoxWrapperPropsType) =>
    props.focusable && {
      ...FOCUSABLE_PROPS,
    }
)<BoxWrapperPropsType>(boxStyles);
